import i18n from '@/i18n'
import { GET_VEHICLE_GROUPS, GET_VEHICLE_TYPES } from '@/services/api/routeOptimization'
import * as Vehicle from '@/services/rest-api/lib/route-optimization/vehicle'
import * as Product from '@/services/rest-api/lib/route-optimization/product'

export const getTableFilterFields = () => [
  {
    name: 'vehicle_group_id',
    key: 'vehicle_group_id',
    isShow: true,
    label: i18n.t('routeOptimization.fields.vehicleGroup'),
    type: 'value-help-v2',
    placeholder: `${i18n.t('global.form.select')} ${i18n.t(
      'routeOptimization.fields.vehicleGroup'
    )}`,
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: async function (opts) {
      return Vehicle.getVehicleGroup({
        ...opts,
      })
    },
    multiple: true,
    canSelectAll: true,
    tableFields: [
      {
        label: `${i18n.t('routeOptimization.fields.vehicleGroup')}`,
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
    ],
  },

  {
    name: 'vehicle_type_id',
    key: 'vehicle_type_id',
    isShow: true,
    label: i18n.t('routeOptimization.fields.vehicleType'),
    type: 'value-help-v2',
    placeholder: `${i18n.t('global.form.select')} ${i18n.t(
      'routeOptimization.fields.vehicleType'
    )}`,
    trackBy: 'id',
    displayedBy: 'type',
    listGetter: async function (opts) {
      return Vehicle.getVehicleType({
        ...opts,
      })
    },
    multiple: true,
    canSelectAll: true,
    tableFields: [
      {
        label: i18n.t('routeOptimization.fields.vehicleType'),
        key: 'type',
        isSortable: true,
        isRedirectable: true,
      },
    ],
  },

  {
    name: 'box_type_id',
    key: 'box_type_id',
    isShow: true,
    label: i18n.t('routeOptimization.fields.boxType'),
    type: 'value-help-v2',
    placeholder: `${i18n.t('global.form.select')} ${i18n.t('routeOptimization.fields.boxType')}`,
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: async function (opts) {
      const filters = [...(opts?.filters || []), 'get_all_ids eq true']

      return Vehicle.getBoxType({
        ...opts,
        filters,
      })
    },
    multiple: true,
    canSelectAll: true,
    tableFields: [
      {
        label: i18n.t('routeOptimization.fields.boxType'),
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
    ],
  },

  {
    name: 'product_category',
    isShow: true,
    label: i18n.t('routeOptimization.fields.productCategory'),
    type: 'value-help-v2',
    placeholder: `${i18n.t('global.form.select')} ${i18n.t(
      'routeOptimization.fields.productCategory'
    )}`,
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Product.getProductCategory(),
    multiple: true,
    canSelectAll: true,
    tableFields: [
      {
        label: i18n.t('routeOptimization.fields.productCategory'),
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
    ],
  },

  {
    type: 'range-input',
    key: 'weight_capacity',
    isShow: true,
    label: i18n.t('routeOptimization.fields.capacityWeight'),
    min: {
      name: 'weight_capacity_min',
      key: 'weight_capacity_min',
      label: i18n.t('global.field.minimum'),
      type: 'number',
      validation: 'number|min:0,value|minLessThanMax:weight_capacity_min,weight_capacity_max',
      'validation-messages': {
        minLessThanMax: `${i18n.t('global.field.minimum')} ${i18n.t(
          'global.validation.max'
        )} ${i18n.t('global.field.maximum')}`,
      },
      suffix: 'Kg',
      'validation-behavior': 'live',
      'error-behavior': 'live',
    },
    max: {
      name: 'weight_capacity_max',
      key: 'weight_capacity_max',
      label: i18n.t('global.field.maximum'),
      type: 'number',
      validation: 'number|min:0,value|minLessThanMax:weight_capacity_min,weight_capacity_max',
      'validation-messages': {
        minLessThanMax: `${i18n.t('global.field.minimum')} ${i18n.t(
          'global.validation.max'
        )} ${i18n.t('global.field.maximum')}`,
      },
      suffix: 'Kg',
      'validation-behavior': 'live',
      'error-behavior': 'live',
    },
  },

  {
    type: 'range-input',
    key: 'volume_capacity',
    isShow: true,
    label: i18n.t('routeOptimization.fields.capacityVolume'),
    min: {
      name: 'volume_capacity_min',
      key: 'volume_capacity_min',
      label: i18n.t('global.field.minimum'),
      type: 'number',
      validation: 'number|min:0,value|minLessThanMax:volume_capacity_min,volume_capacity_max',
      'validation-messages': {
        minLessThanMax: `${i18n.t('global.field.minimum')} ${i18n.t(
          'global.validation.max'
        )} ${i18n.t('global.field.maximum')}`,
      },
      suffix: 'Cbm',
      'validation-behavior': 'live',
      'error-behavior': 'live',
    },
    max: {
      name: 'volume_capacity_max',
      key: 'volume_capacity_max',
      label: i18n.t('global.field.maximum'),
      type: 'number',
      validation: 'number|min:0,value|minLessThanMax:volume_capacity_min,volume_capacity_max',
      'validation-messages': {
        minLessThanMax: `${i18n.t('global.field.minimum')} ${i18n.t(
          'global.validation.max'
        )} ${i18n.t('global.field.maximum')}`,
      },
      suffix: 'Cbm',
      'validation-behavior': 'live',
      'error-behavior': 'live',
    },
  },
]

export const tableFilterFields = getTableFilterFields()
